export default __webpack_public_path__ + "icon-properties.eff13fb2db15eacfca09674b48b3a0af.svg";